<div class="container">
  <div *ngIf="!mode; else elseBlock">
    <h1>{{title}}</h1>
    <p>Please select a study mode</p>

    <div class="list-group">
      <a href="#" class="list-group-item list-group-item-action" *ngFor="let mode of modes" (click)="selectMode(mode)">{{mode}}</a>
    </div>
  </div>

  <ng-template #elseBlock>
    <h2>Study mode: {{mode}}</h2>

    <div class="row">
      <h3 class="col-sm-12" style="text-align: center;">{{currentAdjective.text}}</h3>
      <h5 class="col-sm-12" style="text-align: center;">{{currentAdjective.trans}}</h5>

      <div class="col-sm-12">
        <form>
          <div class="input-group mb-3">
            <input [(ngModel)]="answer.text" name="answer" type="text" class="form-control" placeholder="Your answer" aria-label="Your answer" aria-describedby="basic-addon2">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="submit" (click)="submitAnswer()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="text-align: center;">
        <button class="btn btn-link" (click)="selectMode(null)">I'm done, go back</button>
      </div>
    </div>
  </ng-template>
</div>